import { URL_TEMPLATE } from 'src/libs/constant'

/**
 * Declarative sidebar menu configuration.
 *
 * - `permission`: single permission key (string) checked against computed permissions.
 * - `permissions`: array of permission keys — visible if ANY is true (OR logic).
 * - `icon`: filename only, resolved to /image/ui-kit/sidebar/<icon> at render time.
 */
export const menuSidebarConfig = [
  {
    title: 'component.menu.assign_class',
    icon: 'oclock-icon.png',
    key: '/assign-class',
    groupKey: 'operate',
    permissions: ['canUseAssignClassDemoMenu', 'canUseAssignRegClassMenu', 'canUseMakeupLessonMenu'],
    subMenu: [
      {
        title: 'component.menu.assign_class_demo',
        link: URL_TEMPLATE.ASSIGN_CLASS_DEMO_LIST,
        permission: 'canUseAssignClassDemoMenu'
      },
      {
        title: 'component.menu.assign_class_regular',
        link: URL_TEMPLATE.ASSIGN_CLASS_REGULAR_LIST,
        permission: 'canUseAssignRegClassMenu'
      },
      {
        title: 'component.menu.assign_makeup_lesson',
        link: URL_TEMPLATE.ASSIGN_CLASS_MAKEUP_LESSON_LIST,
        permission: 'canUseMakeupLessonMenu'
      }
    ]
  },
  {
    title: 'component.menu.students',
    icon: 'schedule-icon.png',
    key: '/students',
    groupKey: 'student',
    permission: 'canUseStudentMenu',
    subMenu: [
      {
        title: 'component.menu.students_list',
        link: URL_TEMPLATE.STUDENT_LIST,
        permission: 'canUseStudentMenu'
      },
      {
        title: 'component.menu.students_transfer',
        link: URL_TEMPLATE.STUDENT_TRANSFER,
        permission: 'canUseStudentTransferMenu'
      }
    ]
  },
  {
    title: 'component.menu.qcs_income',
    icon: 'evaluate-icon.png',
    key: '/user-information',
    groupKey: 'tutor',
    permission: 'canUseManageTeacherAndQualityControl',
    subMenu: [
      {
        title: 'component.menu.income_information',
        link: URL_TEMPLATE.USER_INFORMATION,
        permission: 'canUseTeacherSalary'
      },
      {
        title: 'component.menu.tutor_quality_report',
        link: URL_TEMPLATE.TUTOR_QUALITY_REPORT,
        permission: 'canUseTutorQualityReport'
      },
      {
        title: 'component.menu.quality_assurance',
        link: URL_TEMPLATE.QUALITY_ASSURANCE_SESSION,
        permission: 'canUseQualityAssuranceSession'
      },
      {
        title: 'component.menu.quality_control',
        link: URL_TEMPLATE.QUALITY_CONTROL_SESSION,
        permission: 'canUseQualityControlSession'
      }
    ]
  },
  {
    title: 'component.menu.calendar',
    icon: 'schedule-icon.png',
    key: '/calendar',
    groupKey: 'tutor',
    permissions: ['canUseTeacherBookingMenu', 'canUseSessionSummaryMenu', 'canUseSessionRegularSummaryMenu', 'canUseSale'],
    subMenu: [
      {
        title: 'component.menu.calendar_teacher',
        link: URL_TEMPLATE.CALENDAR_TEACHER_LIST,
        permissions: ['canUseTeacherBookingMenu', 'canUseSale']
      },
      {
        title: 'component.menu.cancel_calendar_teacher',
        link: URL_TEMPLATE.CALENDAR_TEACHER_CANCEL_SCHEDULE,
        permission: 'canUseTeacherCancelSchedule'
      },
      {
        title: 'component.menu.calendar_demo_summary',
        link: URL_TEMPLATE.CALENDAR_SUMMARY_DEMO,
        permission: 'canUseSessionSummaryMenu'
      },
      {
        title: 'component.menu.calendar_regular_summary',
        link: URL_TEMPLATE.CALENDAR_SUMMARY_REGULAR,
        permission: 'canUseSessionRegularSummaryMenu'
      }
    ]
  },
  {
    title: 'component.menu.waiting_confirm',
    icon: 'confirm-icon.png',
    key: '/waiting_confirm',
    groupKey: 'tutor',
    permission: 'canUseWaitingConfirm',
    subMenu: [
      {
        title: 'component.menu.waiting_confirm_class',
        link: URL_TEMPLATE.WAITING_CONFIRM_LIST,
        permission: 'canUseWaitingConfirm'
      },
      {
        title: 'component.menu.teacher_receive_backup',
        link: URL_TEMPLATE.RECEIVE_BACKUP,
        permission: 'canUseFindTeacherBackup'
      },
      {
        title: 'component.menu.duty_schedule_backup',
        link: URL_TEMPLATE.DUTY_SCHEDULE_BACKUP,
        permission: 'canUseDutyBackup'
      },
      {
        title: 'component.menu.list_observe_backup',
        link: URL_TEMPLATE.LIST_OBSERVE_BACKUP,
        permission: 'canUseListObserveBackup'
      }
    ]
  },
  {
    title: 'component.menu.learn_result',
    icon: 'evaluate-icon.png',
    key: '/learn-result',
    groupKey: 'tutor',
    permissions: ['canUseFeedBackDemoMenu', 'canUseFeedBackSessionMenu'],
    subMenu: [
      {
        title: 'component.menu.statistics_report',
        link: URL_TEMPLATE.STATISTICS_REPORT,
        permission: 'canUseFeedBackSessionMenu'
      },
      {
        title: 'component.menu.learn_result_demo',
        link: URL_TEMPLATE.LEARN_RESULT_DEMO_LIST,
        permission: 'canUseFeedBackDemoMenu'
      }
    ]
  },
  {
    title: 'component.menu.teacher_absence_or_cancel_session',
    icon: 'file-icon.png',
    key: '/absence',
    groupKey: 'tutor',
    permission: 'canUseAbsenceMenu',
    subMenu: [
      {
        title: 'component.menu.manage_teacher_absence',
        link: URL_TEMPLATE.MANAGE_ABSENCE_TEACHER,
        permission: 'canUseManageTeacherAbsence'
      },
      {
        title: 'component.menu.list_cancel_homeroom_class',
        link: URL_TEMPLATE.MANAGE_ABSENCE_HOMEROOM_CLASS,
        permission: 'canUseManageTeacherAbsence'
      },
      {
        title: 'component.menu.manager_support_quit_job',
        link: URL_TEMPLATE.MANAGE_SUPPORT_QUIT_JOB,
        permission: 'canUseManageTeacherAbsence'
      },
      {
        title: 'component.menu.cancel_class_quit_job',
        link: URL_TEMPLATE.CANCEL_CLASS_QUIT_JOB,
        permission: 'canUseTeacherQuiJobAbsence'
      }
    ]
  },
  {
    title: 'component.menu.class',
    icon: 'book-icon.png',
    key: '/class',
    groupKey: 'operate',
    permissions: ['canUseClassDemoMenu', 'canUseClassRegularMenu', 'canUseClassTrainingMenu'],
    subMenu: [
      {
        title: 'component.menu.class_demo',
        link: URL_TEMPLATE.CLASS_DEMO_LIST,
        permission: 'canUseClassDemoMenu'
      },
      {
        title: 'component.menu.class_regular',
        link: URL_TEMPLATE.CLASS_REGULAR_LIST,
        permission: 'canUseClassRegularMenu'
      },
      {
        title: 'component.menu.class_training',
        link: URL_TEMPLATE.CLASS_TRAINING,
        permission: 'canUseClassTrainingMenu'
      }
    ]
  },
  {
    title: 'component.menu.session',
    icon: 'read-book-icon.png',
    key: '/session',
    groupKey: 'operate',
    permission: 'canUseClassRegularSessionMenu',
    subMenu: [
      {
        title: 'component.menu.session_regular',
        link: URL_TEMPLATE.SESSION_REGULAR_LIST,
        permission: 'canUseClassRegularSessionMenu'
      },
      {
        title: 'component.menu.teaching_schedule_today',
        link: URL_TEMPLATE.SESSION_TEACHING_SCHEDULE,
        permission: 'canUseTeachingSchedule'
      },
      {
        title: 'component.menu.session_homework',
        link: URL_TEMPLATE.SESSION_HOMEWORK_LIST,
        permission: 'canUseSearchSessionHomework'
      }
    ]
  },
  {
    title: 'component.menu.operation',
    icon: 'avatar-icon.png',
    key: '/operation',
    groupKey: 'operate',
    permission: 'canUseOperate',
    subMenu: [
      {
        title: 'component.menu.operation_monitor',
        link: URL_TEMPLATE.OPERATION_MONITOR_LIST,
        permission: 'canUseMonitorTicketMenu'
      },
      {
        title: 'component.menu.operation_technical',
        link: URL_TEMPLATE.OPERATION_TECHNICAL_LIST,
        permission: 'canUseTechnicalTicketMenu'
      },
      {
        title: 'component.menu.reschedule_demo',
        link: URL_TEMPLATE.OPERATION_RESCHEDULE_DEMO_LIST,
        permission: 'canUseRescheduleDemoTickketMenu'
      }
    ]
  },
  {
    title: 'component.menu.care_student',
    icon: 'evaluate-icon.png',
    key: '/student-care',
    groupKey: 'student',
    permission: 'canUseFeedback',
    subMenu: [
      {
        title: 'component.menu.student_care_ticket',
        link: URL_TEMPLATE.STUDENT_CARE_TICKET,
        permission: 'canUseStudentCareTicket'
      },
      {
        title: 'component.menu.student_care_periodic_ticket',
        link: URL_TEMPLATE.STUDENT_CARE_PERIODIC_TICKET,
        permission: 'canUseStudentCarePeriodicMenu'
      },
      {
        title: 'component.menu.extended_care_student',
        link: URL_TEMPLATE.STUDENT_LIST_ABOUT_TO_EXPIRE,
        permission: 'canUseStudentExpireMenu'
      },
      {
        title: 'component.menu.customer_survey',
        link: URL_TEMPLATE.CUSTOMER_SURVEY,
        permission: 'canUseCustomSurvey'
      },
      {
        title: 'component.menu.feedback',
        link: URL_TEMPLATE.FEEDBACK,
        permission: 'canUseFeedback'
      }
    ]
  },
  {
    title: 'component.menu.account',
    icon: 'avatar-icon.png',
    key: '/manage',
    groupKey: 'administration',
    permissions: ['canUseUserModule', 'canUseTeacherUser'],
    subMenu: [
      {
        title: 'component.menu.manage_user',
        link: URL_TEMPLATE.MANAGE_USER_LIST,
        permission: 'canUseUserModule'
      },
      {
        title: 'component.menu.manage_teacher',
        link: URL_TEMPLATE.MANAGE_TEACHER_LIST,
        permission: 'canUseTeacherUser'
      },
      {
        title: 'component.menu.manage_homeroom_teacher',
        link: URL_TEMPLATE.MANAGE_HOMEROOM_TEACHER,
        permission: 'canUseUserConfig'
      },
      {
        title: 'component.menu.manage_role',
        link: URL_TEMPLATE.MANAGE_ROLE_LIST,
        permission: 'canUseUserModule'
      },
      {
        title: 'component.menu.virtual_account_list_classin',
        link: URL_TEMPLATE.MANAGE_VIRTUAL_ACCOUNT_CLASSIN,
        permission: 'canUseUserConfig'
      }
    ]
  },
  {
    title: 'component.menu.configuration',
    icon: 'support-icon.png',
    key: '/config',
    groupKey: 'administration',
    permission: 'canUseConfig',
    subMenu: [
      {
        title: 'component.menu.calendar_teacher_config_time_slot',
        link: URL_TEMPLATE.CALENDAR_TEACHER_CONFIG_TIME_SLOT,
        permission: 'canUseUserConfig'
      },
      {
        title: 'component.menu.calendar_teacher_config_frame',
        link: URL_TEMPLATE.CALENDAR_TEACHER_CONFIG_FRAME,
        permission: 'canUseUserConfig'
      },
      {
        title: 'component.menu.configuration_region',
        link: URL_TEMPLATE.CONFIG_REGION,
        permission: 'canUseConfigCalendarTeacherMenu'
      },
      {
        title: 'component.menu.configuration_province',
        link: URL_TEMPLATE.CONFIG_PROVINCE,
        permission: 'canUseConfigCalendarTeacherMenu'
      },
      {
        title: 'component.menu.configuration_school',
        link: URL_TEMPLATE.CONFIG_SCHOOL,
        permission: 'canUseConfigCalendarTeacherMenu'
      },
      {
        title: 'component.menu.configuration_device',
        link: URL_TEMPLATE.CONFIG_DEVICE,
        permission: 'canUseConfigCalendarTeacherMenu'
      },
      {
        title: 'component.menu.configuration_grade',
        link: URL_TEMPLATE.CONFIG_GRADE,
        permission: 'canUseConfigCalendarTeacherMenu'
      },
      {
        title: 'component.menu.configuration_level',
        link: URL_TEMPLATE.CONFIG_LEVEL,
        permission: 'canUseConfigCalendarTeacherMenu'
      },
      {
        title: 'component.menu.configuration_subject',
        link: URL_TEMPLATE.CONFIG_SUBJECT,
        permission: 'canUseConfigCalendarTeacherMenu'
      },
      {
        title: 'component.menu.configuration_study_program',
        link: URL_TEMPLATE.CONFIG_STUDY_PROGRAM,
        permission: 'canUseUserConfig'
      },
      {
        title: 'component.menu.crm_learning_model',
        link: URL_TEMPLATE.CONFIG_LEARNING_MODEL,
        permission: 'canUseConfigLearningModel'
      },
      {
        title: 'component.menu.tutor_file',
        link: URL_TEMPLATE.TUTOR_FILE_LIST,
        permission: 'canUseTutorConfig'
      },
      {
        title: 'component.menu.breach_rules',
        link: URL_TEMPLATE.CONFIG_BREACH_RULES,
        permission: 'canUseBreachRulesConfig'
      },
      {
        title: 'component.menu.salary',
        link: URL_TEMPLATE.CONFIG_SALARY,
        permission: 'canUseSalaryConfig'
      },
      {
        title: 'component.menu.make_up_session_number',
        link: URL_TEMPLATE.CONFIG_MAKE_UP_SESSION_NUMBER,
        permission: 'canUseMakeUpSessionNumberConfig'
      },
      {
        title: 'component.menu.config_teacher_manage',
        link: URL_TEMPLATE.CONFIG_TEACHER_MANAGE,
        permission: 'canUseTutorConfig'
      },
      {
        title: 'component.menu.config_training_specialist',
        link: URL_TEMPLATE.CONFIG_TRAINING_SPECIALIST,
        permission: 'canUseScoreWeightConfig'
      },
      {
        title: 'component.menu.configuration_tutor_tracking_metrics',
        link: URL_TEMPLATE.CONFIG_TUTOR_TRACKING_METRICS,
        permission: 'canUseScoreWeightConfig'
      },
      {
        title: 'component.menu.configuration_component_score_weights',
        link: URL_TEMPLATE.CONFIG_COMPONENT_SCORE_WEIGHTS,
        permission: 'canUseTutorConfig'
      },
      {
        title: 'component.menu.configuration_component_folder',
        link: URL_TEMPLATE.CONFIG_COMPONENT_FOLDER_CLASSIN,
        permission: 'canUseUserConfig'
      },
      {
        title: 'component.menu.config_potential_points',
        link: URL_TEMPLATE.CONFIG_POTENTIAL_POINT,
        permission: 'canUseAdminConfig'
      },
      {
        title: 'component.menu.config_density',
        link: URL_TEMPLATE.CONFIG_DENSITY,
        permission: 'canUseSalaryConfig'
      },
      {
        title: 'component.menu.config_timetable',
        link: URL_TEMPLATE.CONFIG_TIME_TABLE,
        permission: 'canUseUserConfig'
      }
    ]
  }
]
